import React from "react";

export const Subtitle = ({ text }: { text: string }) => (
  <div className="text-lg font-bold capitalize text-[#324B4A]">{text}</div>
);
